"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helper = void 0;
var globalHandlers_1 = __importDefault(require("../handlers/globalHandlers"));
exports.Helper = {
    getNestedValue: function (obj, path) {
        var _a;
        // console.log("::getNestedValue", obj, path);
        if (!obj || !path)
            return undefined;
        var parts = path.split('.');
        var current = obj;
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (current === undefined || current === null)
                return undefined;
            var arrayMatch = part.match(/(\w+)\[(\d+)\]/);
            if (arrayMatch) {
                var prop = arrayMatch[1], index = arrayMatch[2];
                current = (_a = current[prop]) === null || _a === void 0 ? void 0 : _a[parseInt(index, 10)];
            }
            else {
                current = current[part];
            }
        }
        return current;
    },
    stringToColour: function (str) {
        if (str === void 0) { str = ''; }
        var hash = 0;
        for (var i = 0; i < (str === null || str === void 0 ? void 0 : str.length); i++) {
            hash = (str === null || str === void 0 ? void 0 : str.charCodeAt(i)) + ((hash << 5) - hash);
        }
        var colour = '#';
        for (var i = 0; i < 3; i++) {
            var value = (hash >> (i * 8)) & 0xff;
            var smoothValue = Math.floor((value + 128) / 2);
            colour += ('00' + smoothValue.toString(16)).substr(-2);
        }
        return colour;
    },
    initials: function (text) {
        var textArray = text === null || text === void 0 ? void 0 : text.trim().split(' ');
        if (textArray && textArray.length === 1) {
            return textArray[0][0];
        }
        else if (textArray && textArray.length > 1) {
            return textArray[0][0].concat(textArray[textArray.length - 1][0].toUpperCase());
        }
    },
    processLabel: function (elementProps, context) {
        var _a, _b, _c, _d;
        // If label is a string, return it as is
        if (typeof elementProps.label === 'string') {
            return elementProps.label;
        }
        // If there's a template in the label object
        if ((_a = elementProps === null || elementProps === void 0 ? void 0 : elementProps.label) === null || _a === void 0 ? void 0 : _a.template) {
            var template = elementProps.label.template;
            // Replace ${variable} patterns with values from the state
            return template.replace(/\${([^}]+)}/g, function (match, path) {
                var _a, _b;
                // Get the value from state using the nested path
                var value = exports.Helper.getNestedValue((_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[(context === null || context === void 0 ? void 0 : context.rootState) || ''], path);
                // Return the value if found, otherwise use default or the match
                return value !== undefined
                    ? String(value)
                    : typeof elementProps.label === 'object' &&
                        'default' in elementProps.label
                        ? String(elementProps.label.default)
                        : match;
            });
        }
        // For backward compatibility
        if ((_b = elementProps.label) === null || _b === void 0 ? void 0 : _b.storedLocation) {
            var value = exports.Helper.getNestedValue((_d = (_c = context.state) === null || _c === void 0 ? void 0 : _c.dynamic) === null || _d === void 0 ? void 0 : _d[(context === null || context === void 0 ? void 0 : context.rootState) || ''], elementProps.label.storedLocation);
            return value !== undefined
                ? String(value)
                : typeof elementProps.label === 'object' &&
                    'default' in elementProps.label
                    ? String(elementProps.label.default)
                    : '';
        }
        // Fallback to the original label - convert to string if it's an object
        if (typeof elementProps.label === 'object' && elementProps.label !== null) {
            return elementProps.label.default
                ? String(elementProps.label.default)
                : '';
        }
        return elementProps.label || '';
    },
    executeHandlers: function (handlers, event, rootState, context, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _i, handlers_1, handler, handlerFn, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _i = 0, handlers_1 = handlers;
                    _a.label = 1;
                case 1:
                    if (!(_i < handlers_1.length)) return [3 /*break*/, 7];
                    handler = handlers_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    handlerFn = globalHandlers_1.default[handler.action];
                    if (!handlerFn) return [3 /*break*/, 4];
                    // console.log(
                    //   '__redux state Executing handler:',
                    //   handler.action,
                    //   handler.args,
                    //   rootState,
                    //   value,
                    // );
                    // if (typeof value === 'boolean') {
                    //   value = value ? 1 : 0;
                    // }
                    handler.args = __assign(__assign({}, handler.args), { rootState: rootState, event: event, value: value });
                    return [4 /*yield*/, handlerFn(handler.args, context)];
                case 3:
                    result = _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error("Error executing handler ".concat(handler.action, ":"), error_1);
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7: return [2 /*return*/];
            }
        });
    }); },
    getProcessedLabel: function (elementProps, context) {
        var processedLabel = exports.Helper.processLabel(elementProps, context);
        return processedLabel;
    },
    getTransformedLabel: function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, transformer = _c.transformer, value = _c.value, defaultLabel = _c.defaultLabel;
        if ((transformer === null || transformer === void 0 ? void 0 : transformer.type) === 'array' && Array.isArray(value)) {
            return (_b = value === null || value === void 0 ? void 0 : value.map(function (e) { return (e === null || e === void 0 ? void 0 : e[(transformer === null || transformer === void 0 ? void 0 : transformer.displayKey) || 'label']) || defaultLabel; })) === null || _b === void 0 ? void 0 : _b.filter(function (e) { return Boolean(e === null || e === void 0 ? void 0 : e.trim()); }).join(', ');
        }
        else if ((transformer === null || transformer === void 0 ? void 0 : transformer.type) === 'object') {
            return (value === null || value === void 0 ? void 0 : value[(transformer === null || transformer === void 0 ? void 0 : transformer.displayKey) || 'label']) || defaultLabel;
        }
        return value;
    },
};
